import React from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const Loading = () => {
    return (
      <div style={{ width: "100%", textAlign: "center", display: "block" }}>
        <div style={{ color: "rgb(191, 13, 13)", marginTop: "15px", display: "block" }}>
          <FontAwesomeIcon icon={faSpinner} />
          <span style={{marginLeft:"10px"}}>Loading...</span>
        </div>
      </div>
    )
  }

  export default Loading;